import $ from 'jquery';

function addNoName() {
    setTimeout(function() {
        $('.b-museums__item').each(function() {
            if ($(this).hasClass('no-name')) {
                $(this).parents('.slick-slide').addClass('no-name');
            }
        });
    }, 65);
}

function initSlider() {
    $('.js-museums-slider').slick({
        dots: false,
        slidesToShow: 3.6,
        slidesToScroll: 1,
        arrows: true,
        infinite: false,
        useTransform: false,
        responsive: [
        {
            breakpoint: 1800,
            settings: {
                dots: false,
                slidesToShow: 2.8,
                slidesToScroll: 1,
                arrows: true,
                infinite: false,
                useTransform: false,
           }
        },
        {
            breakpoint: 1600,
            settings: {
                dots: false,
                slidesToShow: 2.6,
                slidesToScroll: 1,
                arrows: true,
                infinite: false,
                useTransform: false,
           }
        },
        {
            breakpoint: 1400,
            settings: {
                dots: false,
                slidesToShow: 2.2,
                slidesToScroll: 1,
                arrows: false,
                infinite: false,
                useTransform: false,
           }
        },
        {
            breakpoint: 1200,
            settings: {
                dots: false,
                slidesToShow: 1.5,
                slidesToScroll: 1,
                arrows: false,
                infinite: false,
                useTransform: false,
           }
        },
        {
            breakpoint: 1024,
            settings: {
                dots: false,
                slidesToShow: 2.2,
                slidesToScroll: 1,
                arrows: false,
                infinite: false,
                useTransform: false,
           }
        },
        {
            breakpoint: 520,
            settings: {
                dots: false,
                slidesToShow: 1.1,
                slidesToScroll: 1,
                arrows: false,
                infinite: false,
                useTransform: false,
           }
        }
        ]
    });
}

$(document).ready(function() {
    initSlider();
    addNoName();
    $(window).on('resize', function() {
        addNoName();
    });
    
    $(document).on('click', '.js-vi-button', function() {
        if ($('.b-vi-top-control').is(":hidden")) {
            $('.js-museums-slider').slick('destroy');
        } else {
            initSlider();
            addNoName();
        }
    });
    $(document).on('click', '.b-vi-top-control__version', function() {
        initSlider();
        addNoName();
    });
});


// WEBPACK FOOTER //
// ./src/js/pages/main/museums-slider.js